import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react'
import SearchBox from './Searchbox';

// The map markers.
class MapMarker extends Component {

	constructor(props) {
		super(props);

		this._scrollToId = this._scrollToId.bind(this);
	}

	makeSafeForCSS(name) {
		return name.replace(/[^a-z0-9]/g, function(s) {
		    var c = s.charCodeAt(0);
		    if (c === 32) return '-';
		    if (c >= 65 && c <= 90) return '_' + s.toLowerCase();
		    return '__' + ('000' + c.toString(16)).slice(-4);
		});
	}

	_scrollToId() {
		const store = this.props.data;
		const theId = this.makeSafeForCSS(store.Address);
		const theEl = document.getElementById( theId );

		// I can't believe this is an out of the box function now.
		// document.getElementById(theId).scrollIntoView();

		window.scroll({
			behavior: 'smooth',
			left: 0,
			top: theEl.offsetTop
		});
	}

	render() {

	    const active = this.props.$hover ? 'active' : '';
		const store = this.props.data;

		return (
			<div className={ "tk-store-locator__marker " + active } onClick={this._scrollToId} >
				<div className="tk-store-locator__marker-content" >
					{store.Name} 
				</div>

				<i className="tk-store-locator__marker-pin fa fa-map-marker"></i>
			</div>
		);
	}
}

// The google map.
class Map extends Component {

	static defaultProps = {
		center 			: { lat: 40.7446790, lng: -73.9485420 },
		zoom 			: 7,
		apiKey 			: 'AIzaSyA0dkNmK3tv3OUBBi4-Wgv2wjwojeFGlRw'
	}

	constructor(props) {
		super(props);

		this.state = {
			activeStores 	: this.props.data,
			centerLoc 		: this.props.startLoc,
			zoom 			: this.props.zoom,
		}

		this._onChange = this._onChange.bind(this);
		this.getData = this.getData.bind(this);
	}

	componentDidMount() {
		// this._onChange();
	}

	_onChange = ({center, zoom, bounds}) => {
		this._bounds = bounds;
		const markers = this.props.data;
		const bb = bounds;
		let filteredPlaces = [];

		for ( var i = 0; i < markers.length; i++ ) {
			var p = markers[i];

			// bb is the bounding box
			// (ix,iy) are its top-left coordinates
			// and (ax,ay) its bottom-right coordinates.  
			// p is the point and (x,y) its coordinates.
			if( bb.nw.lat >= p.Latitude && p.Latitude >= bb.se.lat && bb.nw.lng <= p.Longitude && p.Longitude <= bb.se.lng ) {

				// This place is shown in the viewport.
		        filteredPlaces.push(p);
			} 
		}

		// Update the map markers.
		this.setState( { 
			activeStores : filteredPlaces
		}); 

		// Send active stores to store list.
		this.props.sendActiveStores( filteredPlaces );
	}

	getData(val){
		this.setState( { 
			centerLoc 	: { lat: val.locLat, lng: val.locLng },
			zoom 		: 11
		}); 
	}

	render() {

		const mapOptions = { styles: this.props.mapStyle };

		return (
			<div className="tk-store-locator__map">

				<SearchBox 
					className="tk-store-locator__searchbox form-control"
					placeholder="Search by location (state, city, zip, address, etc.)"
					sendData={this.getData}
				/>

				<div style={{height: '400px', width: '100%'}}>

					<GoogleMapReact
						defaultCenter={ this.props.startLoc }
						center={ this.state.centerLoc }
						defaultZoom={ this.props.zoom }
						zoom={ this.state.zoom }
						options={mapOptions}
						onChange={this._onChange}
						bootstrapURLKeys={{
							key: 'AIzaSyA0dkNmK3tv3OUBBi4-Wgv2wjwojeFGlRw',
							language: 'en'
						}}  >

			          {
			            Object
			            .keys( this.props.data )
			            .map(key => <MapMarker 
			            				key={key} 
			            				index={key} 
			            				data={this.props.data[key]} 
			            				lat={ this.props.data[key].Latitude } 
			            				lng={ this.props.data[key].Longitude } 
			            				text={ this.props.data[key].Name } />
			            	)
			          }

					</GoogleMapReact>
				</div>

			</div>
		);
	}
}

export default Map;



// WEBPACK FOOTER //
// ./src/js/Map.js